import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "crm-item__left" }
const _hoisted_2 = { class: "crm-item__center" }
const _hoisted_3 = { class: "crm-item__title" }
const _hoisted_4 = { class: "crm-item__text" }
const _hoisted_5 = { class: "crm-item__right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-link" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_crm_contact_badge = _resolveComponent("crm-contact-badge")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "crm-item__container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(!_ctx.isLinked ? 'linkToContact' : 'navigateToMobiCRM', _ctx.contact.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_crm_contact_badge, { contact: _ctx.contact }, null, 8, ["contact"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.contact.firstName), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.contact.lastName), 1)
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.contactInfo), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!_ctx.isLinked)
        ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            content: _ctx.$t('ContactPreview.AssociateTooltip'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["content"]))
        : (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 1,
            content: _ctx.$t('ContactPreview.AlreadyAssociatedTooltip'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["content"]))
    ])
  ]))
}